<ng-template #loading>
  Loading...
</ng-template>
<ng-container *ngIf="( userInfo$ | async ) as info; loading">
  <h4 class='company-title' id="companyTitle">{{ info.CompanyName }}</h4>
</ng-container>
